module.exports = __webpack_public_path__ + "static/media/td.e6c4d506.svg";